import EventBus from '@/adready-vue/helpers/global/event-bus';
import { MAX_SUB_CATEGORIES_COUNT_ALLOWED } from '@/constant';
import advertiserReportsAPI from '~/api/advertiser-reports';
import { buildQueryString } from '~/helpers/global/url-helpers';

const methods = {
  async fetchEvents(cachedEventOptions = null) {
    this.$store.set('dashboard/filters@defaultEventSelected', {});
    try {
      if (cachedEventOptions === null) {
        const data = await advertiserReportsAPI.events(
          this.advertiser ? this.advertiser.id : 0,
          buildQueryString({
            advertiser: this.advertiser ? this.advertiser.name : '',
            client: this.account ? this.account.name : '',
            pixelId: this.universalPixelId ? this.universalPixelId : '',
          })
        );

        data.forEach((element) => {
          element.open = element.selected;
          if (element.selected) {
            this.$store.set('dashboard/filters@defaultEventSelected', element);
          }
          // initialize to false
          element.isSubCategoriesCountOverMaxAllowed = false;
          // truncate event.children if it has more than MAX_SUB_CATEGORIES_COUNT_ALLOWED
          if (element.children && element.children.length > MAX_SUB_CATEGORIES_COUNT_ALLOWED) {
            element.children = element.children.slice(0, MAX_SUB_CATEGORIES_COUNT_ALLOWED);
            // update numSubCategories to reflect the truncation
            element.numSubCategories = element.children.length;
            // for tooltip visibility
            element.isSubCategoriesCountOverMaxAllowed = true;
          }
        });
        this.$store.set('dashboard/filters@eventOptions', data);
        EventBus.eventsLoaded = true;
        return;
      }
      this.$store.set('dashboard/filters@eventOptions', cachedEventOptions);
      if (this.isNewReportBuilderForAp) {
        EventBus.eventsLoaded = true;
      }
    } catch (err) {
      console.error('error fetching events ->', err);
      if (window.$sentry) {
        if (err._reported !== true) {
          window.$sentry.captureException(err);
          err._reported = true;
        }
      }
      throw err;
    }
  },
};

export default { methods };
